import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import CustomerKPIs from '../components/Customer/CustomerKPIs';
import CustomerProductTable from '../components/Customer/CustomerProductTable';
import CustomerSalesHistory from '../components/Customer/CustomerSalesHistory';
import CustomerVarianceReport from '../components/Customer/CustomerVarianceReport';

const { FiUsers, FiTrendingUp, FiPackage, FiBarChart } = FiIcons;

const CustomerDetails = () => {
  const { customerId } = useParams();
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', name: 'Overview & KPIs', icon: FiTrendingUp },
    { id: 'products', name: 'Product Portfolio', icon: FiPackage },
    { id: 'history', name: 'Sales History', icon: FiBarChart },
    { id: 'variance', name: 'Variance Reports', icon: FiBarChart }
  ];

  const customerName = customerId.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());

  const renderTabContent = () => {
    switch (activeTab) {
      case 'overview':
        return <CustomerKPIs customerId={customerId} />;
      case 'products':
        return <CustomerProductTable customerId={customerId} />;
      case 'history':
        return <CustomerSalesHistory customerId={customerId} />;
      case 'variance':
        return <CustomerVarianceReport customerId={customerId} />;
      default:
        return <CustomerKPIs customerId={customerId} />;
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6"
      >
        <div className="flex items-center gap-4 mb-4">
          <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-emerald-600 rounded-xl flex items-center justify-center">
            <SafeIcon icon={FiUsers} className="text-white text-xl" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{customerName}</h1>
            <p className="text-gray-600">Customer analytics and performance metrics</p>
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                  activeTab === tab.id
                    ? 'border-green-500 text-green-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <SafeIcon icon={tab.icon} />
                {tab.name}
              </button>
            ))}
          </nav>
        </div>
      </motion.div>

      {/* Tab Content */}
      <motion.div
        key={activeTab}
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.3 }}
      >
        {renderTabContent()}
      </motion.div>
    </div>
  );
};

export default CustomerDetails;